import { combineReducers } from 'redux';

import waitingListReducer from './app/waitingList/reducer';
import receiptReducer from './app/receipt/reducer';
import appReducer from './app/reducer';
import citiesReducer from './app/cities/reducer';
import shopsReducer from './app/shops/reducer';
import barbersReducer from './app/barbers/reducer';
import servicesReducer from './app/services/reducer';
import timesReducer from './app/times/reducer';
import reservationReducer from './app/reservation/reducer';
import confirmationReducer from './app/confirmation/reducer';
import positionReducer from './app/position/reducer';
import campaignReducer from './app/campaign/reducer';
import instantExperiencesReducer from './app/instantExperiences/reducer';
import acceptCookiesReducer from './app/acceptCookies/reducer';
import daysOffReducer from './app/daysOff/reducer';
import extensionsReducer from './app/extensions/reducer';
import giftCardReducer from './app/giftCard/reducer';
import passcodeReducer from './app/passcode/reducer';
import membershipReducer from './app/membership/reducer';

export default combineReducers({
  app: appReducer,
  cities: citiesReducer,
  shops: shopsReducer,
  barbers: barbersReducer,
  services: servicesReducer,
  times: timesReducer,
  reservation: reservationReducer,
  confirmation: confirmationReducer,
  position: positionReducer,
  receipt: receiptReducer,
  waitingList: waitingListReducer,
  campaign: campaignReducer,
  instantExperiences: instantExperiencesReducer,
  acceptCookie: acceptCookiesReducer,
  daysOff: daysOffReducer,
  extensions: extensionsReducer,
  giftCard: giftCardReducer,
  passcode: passcodeReducer,
  membership: membershipReducer,
});



// WEBPACK FOOTER //
// ./src/reducer.js